// Presentational helpers for CalendarView (lint split).
import { Box } from '@mui/material';

export function buildHourlyLabels(startHour, endHour) {
  const labels = [];
  for (let hour = startHour; hour < endHour; hour++) {
    labels.push(`${hour.toString().padStart(2, '0')}:00`);
  }
  return labels;
}

export function renderCalendarKeyboardHint(keyboardHintId, hintText) {
  return (
    <Box
      component="span"
      id={keyboardHintId}
      sx={{
        position: 'absolute',
        width: 1,
        height: 1,
        p: 0,
        m: -1,
        overflow: 'hidden',
        clip: 'rect(0,0,0,0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      {hintText}
    </Box>
  );
}
